import { Extension } from "@tiptap/core";
import { Plugin } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { postPlaceholders } from "@stackje/site-builder";

/** Marks missing specifics without changing the owner's words or their Markdown. */
export const PostPlaceholderMarks = Extension.create({
  name: "postPlaceholderMarks",
  addProseMirrorPlugins() {
    return [new Plugin({ props: { decorations(state) {
      const marks: Decoration[] = [];
      state.doc.descendants((node, pos) => {
        if (node.isText && node.text) for (const placeholder of postPlaceholders(node.text)) marks.push(Decoration.inline(pos + placeholder.from, pos + placeholder.to, { class: "bw-blog-placeholder", "data-post-placeholder": "" }));
      });
      return DecorationSet.create(state.doc, marks);
    } } })];
  },
});
